import type { ReactNode } from 'react';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Auth } from 'pages/auth';
import { CargoPage } from 'pages/cargos/cargo';
import { CargosListPage } from 'pages/cargos/cargos-list';
import { ClientPage } from 'pages/clients/client';
import { ClientsListPage } from 'pages/clients/clients-list';
import { CostsPerKmPage } from 'pages/company/costs-per-km';
import { TransportsPage } from 'pages/company/transports';
import { UsersPage } from 'pages/company/users';
import { WarehousesPage } from 'pages/company/warehouses';
import { ExpensePage } from 'pages/expenses/expense';
import { ExpensesListPage } from 'pages/expenses/expenses-list';
import { Home } from 'pages/home/home.tsx';
import { InvoicePage } from 'pages/invoices/invoice';
import { InvoicesListPage } from 'pages/invoices/invoices-list';
import { OrderPage } from 'pages/orders/order';
import { OrdersListPage } from 'pages/orders/orders-list';
import { DistributionEfficiencyPage } from 'pages/statistics/distribution-efficiency';
import { FuturePaymentsPage } from 'pages/statistics/future-payments';
import { OverduePage } from 'pages/statistics/overdue';
import { ProfitStatisticPage } from 'pages/statistics/profit-statistic';
import { TransportLoadPage } from 'pages/statistics/transport-load';
import { TransportMileagePage } from 'pages/statistics/transport-mileage';
import { WhPerformancePage } from 'pages/statistics/wh-performance';
import { TripPage } from 'pages/trips/trip';
import { TripsListPage } from 'pages/trips/trips-list';
import { WhInfoPage } from 'pages/wh-info';
import { WhTaskPage } from 'pages/wh-tasks/wh-task';
import { WhTasksListPage } from 'pages/wh-tasks/wh-tasks-list/wh-tasks-list.page.tsx';
import { GlobalLayout } from 'layouts/global-layout';
import { useAuthStore } from 'shared/stores';
import { routePaths } from './route-paths.ts';

interface IRoutes {
  path: string;
  element: ReactNode;
}

export const Router: React.FC = () => {
  const routes: IRoutes[] = [
    {
      path: routePaths.home,
      element: <Home />,
    },
    {
      path: routePaths.orders,
      element: <OrdersListPage />,
    },
    {
      path: routePaths.order,
      element: <OrderPage />,
    },
    {
      path: routePaths.cargos,
      element: <CargosListPage />,
    },
    {
      path: routePaths.cargo,
      element: <CargoPage />,
    },
    {
      path: routePaths.users,
      element: <UsersPage />,
    },
    {
      path: routePaths.trips,
      element: <TripsListPage />,
    },
    {
      path: routePaths.trip,
      element: <TripPage />,
    },
    {
      path: routePaths.invoices,
      element: <InvoicesListPage />,
    },
    {
      path: routePaths.invoice,
      element: <InvoicePage />,
    },
    {
      path: routePaths.expenses,
      element: <ExpensesListPage />,
    },
    {
      path: routePaths.expense,
      element: <ExpensePage />,
    },
    {
      path: routePaths.clientsList,
      element: <ClientsListPage />,
    },
    {
      path: routePaths.client,
      element: <ClientPage />,
    },
    {
      path: routePaths.warehouses,
      element: <WarehousesPage />,
    },
    {
      path: routePaths.transports,
      element: <TransportsPage />,
    },
    {
      path: routePaths.costsPerKm,
      element: <CostsPerKmPage />,
    },
    {
      path: routePaths.transportPerformance,
      element: <TransportMileagePage />,
    },
    {
      path: routePaths.whTasks,
      element: <WhTasksListPage />,
    },
    {
      path: routePaths.whTask,
      element: <WhTaskPage />,
    },

    {
      path: routePaths.transportLoad,
      element: <TransportLoadPage />,
    },
    {
      path: routePaths.distributionEfficiency,
      element: <DistributionEfficiencyPage />,
    },
    {
      path: routePaths.statisticProfit,
      element: <ProfitStatisticPage />,
    },
    {
      path: routePaths.whPerformance,
      element: <WhPerformancePage />,
    },
    {
      path: routePaths.overdue,
      element: <OverduePage />,
    },
    {
      path: routePaths.futurePayments,
      element: <FuturePaymentsPage />,
    },
    {
      path: routePaths.whInfo,
      element: <WhInfoPage />,
    },
  ];

  const { isAuth } = useAuthStore();

  return (
    <BrowserRouter>
      <Routes>
        {isAuth ? (
          <>
            <Route path={'/'} element={<GlobalLayout />}>
              {routes.map((route) => (
                <Route key={route.path} path={route.path} element={route.element} />
              ))}
            </Route>
            <Route path={'*'} element={<Navigate to={routePaths.cargos} replace />} />
          </>
        ) : (
          <>
            <Route path={routePaths.auth} element={<Auth />} />
            <Route path={'*'} element={<Navigate to={routePaths.auth} replace />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
};
